/**
 * Group Management Statistics Cards
 * Displays statistics about groups in a grid layout
 */

import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import {
  Groups as GroupsIcon,
  Business as BusinessIcon,
  Cloud as CloudIcon,
  People as PeopleIcon,
} from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';


interface GroupStats {
  total: number;
  local: number;
  external: number;
  bySource: Record<string, number>;
}

interface GroupManagementStatsProps {
  stats: GroupStats;
  myGroupsCount: number;
}

export const GroupManagementStats: React.FC<GroupManagementStatsProps> = ({
  stats,
  myGroupsCount,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Main Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <GroupsIcon color="primary" sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="h4">{stats.total}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t('groups.labels.totalGroups')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <BusinessIcon color="primary" sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="h4">{stats.local}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t('groups.labels.localGroupsCount')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CloudIcon color="info" sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="h4">{stats.external}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t('groups.labels.externalGroupsCount')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <PeopleIcon color="success" sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="h4">{myGroupsCount}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t('groups.labels.myGroupsCount')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Source Breakdown Card */}
{/*       
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {t('groups.labels.groupsBySource')}
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            {Object.entries(stats.bySource).map(([source, count]) => {
              const SourceIcon = getSourceIcon(source);
              return (
                <Chip
                  key={source}
                  icon={<SourceIcon />}
                  label={`${source.toUpperCase()}: ${count}`}
                  color={getSourceColor(source)}
                  variant="outlined"
                />
              );
            })}
          </Box>
        </CardContent>
      </Card> */}
    </>
  );
};